import React from 'react';
import PropTypes from 'prop-types';
import FullPageMessage from '../../../common/fullPageMessage/FullPageMessage';
import {
	ONBOARDING_ERROR_ALREADY_TRUSTED_PARTY_PERIOD_TITLE,
	ONBOARDING_ERROR_ALREADY_TRUSTED_PARTY_PERIOD_DESCRIPTION,
	ONBOARDING_ERROR_ALREADY_TRUSTED_PARTY_PERIOD_DESCRIPTION_WITH_TRUSTEDPARTY,
} from '../../../../constants/Copy';
import { useParams } from 'react-router';

const DefaultAlreadyTrustedParty = () => {
	const { partnerName } = useParams();

	const description = !partnerName
		? ONBOARDING_ERROR_ALREADY_TRUSTED_PARTY_PERIOD_DESCRIPTION
		: ONBOARDING_ERROR_ALREADY_TRUSTED_PARTY_PERIOD_DESCRIPTION_WITH_TRUSTEDPARTY.replaceAll(
				'{trustedParty}',
				partnerName
		  );

	return (
		<FullPageMessage
			title={ONBOARDING_ERROR_ALREADY_TRUSTED_PARTY_PERIOD_TITLE}
			description={description}
		/>
	);
};

DefaultAlreadyTrustedParty.propTypes = {
	history: PropTypes.object.isRequired,
};

export default DefaultAlreadyTrustedParty;
